var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-history-entry__field-content"},[_c('div',{staticClass:"row-history-entry__diff",class:_vm.action === 'deleted'
        ? 'row-history-entry__diff--removed'
        : 'row-history-entry__diff--added'},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }